import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ScrollToTop from "./Component/TopScroll/ScrollToTop";
// import navbar from "./Component/Navbar";
import VenuesPage from "./Pages/VenuesPage";
import DetailsPage from "./Pages/DetailsPage";
import Navbar from "./Component/Navbar";
import AboutPage from "./Pages/AboutPage";
import FaqPage from "./Pages/FaqPage";
import BlogPage from "./Pages/BlogPage";
import Footer from "./Component/FooterCom/Footer";
import VendorForm from "./Pages/VendorForm";
import BlogView from "./Pages/BlogView";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        {/* <HeadMain /> */}
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HomePage />
              </>
            }
          />
          <Route path="/Home" element={<HomePage />} />
          <Route path="/vendors" element={<VenuesPage />} />
          {/* <Route path='/details' element={<DetailsPage />} /> */}
          <Route path="/about-page" element={<AboutPage />} />
          {/* <Route path='/vendors/:category/:subcategory' element={<VenuesPage />} /> */}
          <Route path="/vendors/:city/:category" element={<VenuesPage />} />
          <Route path="/vendors/:community" element={<VenuesPage />} />
          <Route
            path="/details/:vendorSlug"
            element={<DetailsPage />}
          />
          {/* <Route path='/vengors/:subcategory' element={<VenuesPage />} /> */}
          <Route path="/faqs" element={<FaqPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          {/* <Route path='/vengors/:vendorList/:vendorSlug' element={<DetailsPage />} /> */}
          {/* <Route path='/wedding-venues/:venue_id' element={<DetailsPage />} /> */}
          {/* <Route path='/vendors/all/wedding-venues/' element={<DetailsPage />} /> */}
          <Route path="/are-you-vendor" element={<VendorForm />} />
          <Route path="/view/:id" element={<BlogView />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
